import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SERVICES_PAGE_PATH } from '../shared/constants';
import { ServicesComponent } from './services.component';

const routes: Routes = [
  {
    path: SERVICES_PAGE_PATH,
    component: ServicesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServicesRoutingModule {}
